/**
 * @class
 * @description This class stores information about the video resource.
 * @exports Resource
 */
export default class Resource {
    constructor() {
        this.masterUri = '';
        this.renditions = new Map();
        this.route = '';
        this.fileName = '';
        this.bandwidths = [];
    }
    addRendition(uri, rendition) {
        this.renditions.set(uri, rendition);
        this.updateAvailableBandwidths();
    }
    getRenditions() {
        return this.renditions;
    }
    getVideoRenditions() {
        let vidoeRenditions = new Map();
        this.renditions.forEach(function (value, key) {
            if (!value.isAudio)
                vidoeRenditions.set(key, value);
        });
        return vidoeRenditions;
    }
    getRendition(segmentUri) {
        let resultRendition;
        this.renditions.forEach(function (rendition) {
            rendition.segments.forEach(function (segment) {
                if (segmentUri.endsWith(segment.uri)) {
                    resultRendition = rendition;
                }
            });
        });
        return resultRendition;
    }
    updateAvailableBandwidths() {
        let bandwidth = new Array();
        this.renditions.forEach(function (rendition) {
            if (!rendition.isAudio)
                bandwidth.push(Number(rendition.bandwidth));
        });
        bandwidth.sort(function (x, y) {
            return x - y;
        });
        this.bandwidths = bandwidth;
        console.log(bandwidth);
        this.renditions.forEach(rendition => {
            if (!rendition.isAudio) {
                rendition.bandwidthPosition = this.getBandwidthsPos(rendition.bandwidth);
                if (rendition.bandwidthPosition + 1 == this.bandwidths.length) {
                    //console.log("Max bandwidth -> "+rendition.bandwidth);  
                    rendition.isMaxRendition = true;
                }
            }
        });
    }
    getBandwidthsPos(currentBandwidth) {
        let i = 0;
        let result = -1;
        this.bandwidths.forEach(function (bandwidth) {
            if (currentBandwidth == bandwidth) {
                result = i;
            }
            i++;
        });
        return result;
    }
}
